import * as React from 'react';

import { AlertBase, AlertVariant } from '../AlertBase';

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * @children required
   */
  children: React.ReactNode;
  /**
   * Enables additional right aligned children within the Alert.
   */
  additionalContent?: React.ReactNode;
  /**
   * The text read by screen readers for the close button
   * @default "Close this message"
   */
  closeAriaLabel?: string;
  /**
   * If true, the component will be able to be dismissed and will include a close button
   * @default false
   */
  isDismissible?: boolean;
  /**
   * Reference to the dismiss button element
   */
  dismissibleButtonRef?: React.Ref<HTMLButtonElement>;
  isInverse?: boolean;
  /**
   * Action that fires when the close button is clicked (required when isDismissible is true)
   */
  onDismiss?: () => void;
  /**
   * @internal
   */
  testId?: string;
  /**
   * The variant of the alert, indicating its function in the UI
   * @default AlertVariant.info
   */
  variant?: AlertVariant;
}

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  (props, ref) => {
    return <AlertBase ref={ref} {...props} />;
  }
);
